import type { ReactNode } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

type CommonAccordionProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
  keepMounted?: boolean;
};

export function CommonAccordion({
  title,
  isOpen,
  onToggle,
  children,
  keepMounted = false,
}: CommonAccordionProps) {
  return (
    <section className="overflow-visible rounded-xl border border-theme-border bg-theme-surface shadow-sm">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 bg-theme-surface-subtle px-4 py-4 text-left"
        onClick={onToggle}
      >
        <span className="text-sm font-semibold text-theme-primary">{title}</span>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 shrink-0 text-theme-text-soft" />
        ) : (
          <ChevronDown className="h-5 w-5 shrink-0 text-theme-text-soft" />
        )}
      </button>

      {keepMounted ? (
        <div
          className={`relative overflow-visible border-t border-theme-border p-4 ${isOpen ? "block" : "hidden"}`}
          aria-hidden={!isOpen}
        >
          {children}
        </div>
      ) : isOpen ? (
        <div className="relative overflow-visible border-t border-theme-border p-4">{children}</div>
      ) : null}
    </section>
  );
}
